import PropTypes from 'prop-types'
import React, {  useState } from "react";
import { Col, Modal,  Row , Label,Alert,Form,Button} from "reactstrap"

import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
// Redux
import { connect, useDispatch, useSelector} from "react-redux";

import {  withRouter,} from "react-router-dom";


import { casosCreate } from  "../../../store/casos/actions"
import { casosFullList } from "../../../store/casos/actions";


import ComponentsMantenimiento  from '../../../components/Common/ComponentsMantenimiento'
const CrearCasoModal = ({caso, onCloseCasoClick}) => {

    const dispatch= useDispatch();
    const state = useSelector(state => state.Casos) || []
    const [image_file, setImage_file] = useState("")


    console.log(state)

    const [selectedTipoVisita, setselectedTipoVisita] = useState(null)
    const [selectedTipoServicio, setSelectedTipoServicio] = useState(null)
    const [selectedContacto, setSelelectedContacto] = useState(null)

    const contact = useSelector(state => state.Contacts.contacts) || []

    function handleSelectContacto(selectedContacto){
        setSelelectedContacto(selectedContacto.value)
      }

    function handleSelectTipoVisita(selectedTipoVisita) {
        setselectedTipoVisita(selectedTipoVisita.value);
      
      }

      function handleSelectTipoServcio(selectedTipoServicio){
        setSelectedTipoServicio(selectedTipoServicio.value)
      }
      //Options
   const TipoVisita = [
    {

      options: [
        { label: "VISITA CONTRATO", value: "VISITA CONTRATO" },
        { label: "VISITA ADICIONAL", value: "VISITA ADICIONAL" },
        { label: "VENTA", value: "VENTA" },
        { label: "GARANTIA", value: "GARANTIA" },
        { label: "REVISION O REPARACION", value: "REVISION O REPARACION" },
        { label: "ENTREGA", value: "ENTREGA" },
        {
          label: "LEVANTAMIENTO DE INFORMACION",
          value: "LEVANTAMIENTO DE INFORMACION",
        },
        {
          label: "MANTENIMIENTO PREVENTIVO",
          value: "MANTENIMIENTO PREVENTIVO",
        },
        {
          label: "MANTENIMIENTO CORRECTIVO",
          value: "MANTENIMIENTO CORRECTIVO",
        },
        { label: "MENSAJERIA", value: "MENSAJERIA" },
        { label: "COMPRAS", value: "COMPRAS" },
        { label: "PARTNER", value: "PARTNER" },
        { label: "COTIZAR EN EL SITIO", value: "COTIZAR EN EL SITIO" },
        { label: "INSTALACION", value: "INSTALACION" },
      ],
    },

  ];

  const TipoServicio= [
    {

      options: [
        { label: "Presencial", value: "PRESENCIAL" },
        { label: "Remoto", value: "REMOTO" },
        { label: "Mixto", value: "MIXTO" }
     
      ],
    },

  ];

  const[formData, setFormData] = useState({
    observaciones:"",
    detallesServicio:"",
  
  })
  
  const {
    observaciones,
    detallesServicio,
    
  } = formData
  
  const onChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value})
  }

  const contacto = selectedContacto;
  const tipo_visita = selectedTipoVisita;
  const tipo_servicio = selectedTipoServicio;




  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(casosCreate({
      contacto,
      tipo_visita,
      tipo_servicio,
      observaciones,
      detallesServicio,
      image_file,
     
    }));
    
   };


    return ( <>


    <ComponentsMantenimiento
    setImage_file={setImage_file}
    ></ComponentsMantenimiento>
   {state.casosCreated.id ? (
                            <SweetAlert
                              title="Hecho!"
                              success
                              timeout={1000}
                              showConfirm={false}
                              onConfirm={() => {
                                onCloseCasoClick();
                                dispatch(casosFullList())
                              }}
                            >
                              Se ha agregado el Caso  con el numero {state.casosCreated.id}
                            </SweetAlert>
                          ) : null}


        <Modal isOpen={caso} 
        toggle={onCloseCasoClick} 
        centered={true}
        size="lg"
        >
        <div className="modal-header">
            <h3 className="modal-title mt-2">
                Crear Caso
            </h3>
            <button
                type='button'
                onClick={()=>{
                    onCloseCasoClick()
                }
                
                }
                className="close"
                data-dismiss="modal"
                aria-label="Close"
            >
                 <span aria-hidden="true">&times;</span>
            </button>

        </div>

          {/* Formulario de Casos */}
          <div className="modal-body">



                                            <Form 
                                            onSubmit={onSubmit}
                                            >

                                                <Row>

                                                <Label
                                                            
                                                            for="accountlist"
                                                            className="col-form-label col-sm-4 d-flex"
                                                          >
                                                        <strong>Contacto</strong><span className="text-danger">*</span> 
                                                          </Label>

                                                       
                                                          <Select  
                                                           
                                                           id="accountlist"
                                                           name="accountlist"
                                                           placeholder ="Seleccione"
                                                           
                                                           onChange={handleSelectContacto}
                                                           options ={ contact && contact.map(item => ({label:(item.first_name?item.first_name:item.razon_social), value:item.id}))}
                                                           
                                                         />

                                                </Row>

                                            {/* Tipo de Visita */}
                                                    <Row>

                                                    <Label
                                                            for="tipo_visita"
                                                            className="form-label mt-2"
                                                        >
                                                            Tipo de Visita
                                                        </Label>
                                                        <Select
                                                        
                                                            id="tipo_visita"
                                                            name="tipo_visita"
                                                            
                                                            
                                                            onChange={handleSelectTipoVisita}
                                                            options={TipoVisita}
                                                            autoFocus

                                                        />

                                                            {state.error && state.error.tipo_visita ? (
                                                            <Alert color = 'danger' className="mt-2">{state.error.tipo_visita}</Alert>
                                                            ):null}
                                                    </Row>


                                                    {/* Tipo de Servicio */}

                                                    <Row>

                                                        <Label
                                                            for="tipo_visita"
                                                            className="form-label mt-2"
                                                        >
                                                            Tipo de Servicio
                                                        </Label>
                                                        <Select
                                                        
                                                            id="tipo_servicio"
                                                            name="tipo_servicio"
                                                            
                                                            options={TipoServicio}
                                                            onChange={handleSelectTipoServcio}
                                                            
                                                            autoFocus

                                                        />

                                                        {state.error && state.error.tipo_servicio ? (
                                                            <Alert color = 'danger' className="mt-2">{state.error.tipo_servicio}</Alert>
                                                            ):null}
                                                    </Row>


                                                            {/* Detalles del Servicio */}

                                                            <Row>

                                                                            <Label
                                                                        for="detallesServicio"
                                                                        className="col-form-label col-sm-4 d-flex"
                                                                    >
                                                                    <strong>Detalles del Servicio </strong> 
                                                                    </Label>

                                                                    <textarea
                                                                        className="form-control"
                                                                        id="detallesServicio"
                                                                        name="detallesServicio"
                                                                        type="textarea"
                                                                        rows="2"
                                                                        onChange={onChange}
                                                                        
                                                                    
                                                                        
                                                                        
                                                                    />
                                                                        {state.error && state.error.detallesServicio ? (
                                                                <Alert color = 'danger' className="mt-2">{state.error.detallesServicio}</Alert>
                                                                ):null}
                                                            </Row>

                                                                        {/* Observaciones */}

                                                            <Row>

                                                            <Label
                                                                    for="observaciones"
                                                                    className="col-form-label col-sm-4 d-flex"
                                                                >
                                                                <strong>Observaciones </strong> 
                                                                </Label>

                                                                <textarea
                                                                    className="form-control"
                                                                    id="observaciones"
                                                                    name="observaciones"
                                                                    type="textarea"
                                                                    rows="4"
                                                                    onChange={onChange}
                                                                    
                                                                
                                                                    
                                                                    
                                                                />
                                                                {state.error && state.error.observaciones ? (
                                                            <Alert color = 'danger' className="mt-2">{state.error.observaciones}</Alert>
                                                            ):null}
                                                            </Row>

                                                <Row className="col-lg-12 justify-content-center">
                                                <Col md={1} className= 'mx-3'>
                                                    <Button color="primary" type="submit">
                                                    Enviar
                                                    </Button>
                                                </Col>
                                                <Col md={1} className= 'mx-3'>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        onCloseCasoClick()
                                                    }}
                                                >
                                                    Cerrar
                                                </button>
                                                </Col>
                                                </Row>
                                            </Form>
                                                            


                                        </div>
        </Modal>
        </>
       
     );
}
 
const mapStateToProps = (state) => {
    const { error, loading, casos,casosCreated } = state.Casos;
    return { error, loading,casos, casosCreated };
  };
  
  CrearCasoModal.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    casosCreated: PropTypes.object,
  }
  
  
   
  export default withRouter(connect(mapStateToProps, {casosCreate})(CrearCasoModal));
  